import type { GuideContextualHelp } from "../types/guide-content.types.ts"

export const GUIDE_CONTEXTUAL_HELP: GuideContextualHelp[] = [
  {
    id: "what-is-a-lead",
    titleKey: "guide.contextualHelp.whatIsALead.title",
    bodyKey: "guide.contextualHelp.whatIsALead.body",
    relatedTourId: "leads-pipeline",
    relatedLessonId: "leads-what-is-a-lead"
  }
]

export const getGuideContextualHelp = (
  id: string
): GuideContextualHelp | null =>
  GUIDE_CONTEXTUAL_HELP.find((entry) => entry.id === id) ?? null
